export const routes = (prefix) => [
    {
        path: `/${prefix}/expenses`,
        name: `${prefix}.expenses.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.expenses.index`,
                PageDescription: "Expenses Listing/Capture",
            }
        }
    },
];
